<app-dialog
  #dialog
  [key]="'pit-asset-edit'"
  [action]="'pit-asset-edit'"
  [headerTheme]="'simple'"
  [title]="'Editar bem para garantia'"
  [appendTo]="'body'"
  [maxWidth]="'680px'">
  @if (asset(); as item) {
    <form class="pit-asset-form" [formGroup]="form" appAutoFormGroup>
      <p class="pit-asset-form__help">
        {{ item.group }} · {{ item.groupLabel }}. O que você mudar aqui vale para a análise de
        garantias deste sócio e fica marcado como ajuste do analista. A declaração não muda.
      </p>

      <div class="pit-asset-form__field">
        <app-input
          [id]="shortNameInputId"
          [controlName]="'shortName'"
          [label]="'Nome curto do bem'"
          [textCenter]="false"
          [maxLength]="shortNameMax" />
        <!-- Contador cinza até a pessoa editar o nome; o limite só vale para nome editado. -->
        <span class="pit-asset-form__hint" [class.pit-asset-form__hint--error]="shortNameTooLong()">
          {{ shortNameLength() }}/{{ shortNameMax }}
          @if (shortNameTooLong()) {
            · encurte o nome para salvar
          }
        </span>
      </div>

      <!-- Valor, origem e data na mesma linha, com a mesma largura e alinhados pela base. -->
      <div class="pit-asset-form__row pit-asset-form__row--3 pit-asset-form__row--bottom">
        <app-input
          [controlName]="'referenceValueThousands'"
          [type]="'number'"
          [label]="'Valor (R$ mil)'"
          [maxFractionDigits]="0"
          [textCenter]="false" />
        <app-select
          [controlName]="'referenceSource'"
          [label]="'Origem do valor'"
          [options]="sourceOptions"
          [hasFilter]="false" />
        <app-calendar [controlName]="'referenceDate'" [label]="'Data do valor'" />
      </div>

      <div class="pit-asset-form__row pit-asset-form__row--2">
        <app-select
          [controlName]="'eligibility'"
          [label]="'Situação'"
          [options]="eligibilityOptions"
          [hasFilter]="false"
          [allowEmptyPlaceholderSelect]="false" />
        <div class="pit-asset-form__field">
          <app-input
            [controlName]="'committedThousands'"
            [type]="'number'"
            [label]="'Já comprometido (R$ mil)'"
            [maxFractionDigits]="0"
            [placeholder]="'Nada comprometido'"
            [textCenter]="false" />
          <span class="pit-asset-form__hint">Em outras operações</span>
        </div>
      </div>

      <app-input
        [controlName]="'restrictions'"
        [type]="'textarea'"
        [label]="'Restrições (uma por linha)'"
        [placeholder]="'Ex.: exige anuência do cônjuge'"
        [textCenter]="false"
        [maxLength]="1000" />
    </form>
  }

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        theme="outline-grey"
        [outlined]="true"
        [fitContent]="true"
        [disabled]="submitting()"
        (sendButtonClick)="cancel()" />
      <app-button
        [label]="'Salvar'"
        [fitContent]="true"
        [disabled]="!isFormValid()"
        [isLoading]="submitting()"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
